import { useParams } from "react-router-dom";

const documents = {
  terms: { title: "用户协议", sections: ["共享朋友圈用于发布游戏动态、记录成长经历和开展站内交流；平台不参与任何商品交易。", "您应保证发布内容真实、合法且不包含第三方联系方式、支付信息或私下交易诱导。", "违反社区规则的账号可能被限制发布、暂停交流或永久封禁。"] },
  privacy: { title: "隐私政策", sections: ["平台仅收集提供账号、内容发布和站内交流所需的信息。", "聊天记录按平台公布的留存周期保存，仅在纠纷核查、安全调查或法律要求下由授权管理员访问，查询行为会被审计。", "生产上线前应由法务确认具体的数据留存周期、用户权利响应和第三方服务清单。"] },
  community: { title: "社区规范", sections: ["鼓励分享真实的游戏日常、成长记录、攻略心得和友好讨论，禁止骚扰、误导或冒充他人。", "禁止在动态、图片、私信和群聊中发布站外联系方式、诱导私下转账或发布虚假素材。", "官方群仅由平台创建。用户不能自行建群，也不能删除后台留存的聊天证据。"] },
  report: { title: "举报与申诉", sections: ["发现私下交易诱导、虚假素材或其他违规内容时，请记录对应动态、会话或群聊信息并联系平台运营。", "处罚应提供原因、影响范围和申诉路径。图片 OCR 可能误判，严重处罚前应由人工复核。", "当前开发版本提供后台违规记录和审计链路，生产环境应配置正式客服入口与处置时限。"] }
} as const;

export function LegalPage() {
  const { document = "terms" } = useParams();
  const content = documents[document as keyof typeof documents] ?? documents.terms;
  return <article className="page-shell legal-page"><span className="eyebrow">平台规则</span><h1>{content.title}</h1><p className="legal-updated">版本日期：2026-08-25</p>{content.sections.map((section, index) => <section key={section}><h2>{index + 1}. {index === 0 ? "适用范围" : index === 1 ? "平台规则" : "处置与责任"}</h2><p>{section}</p></section>)}</article>;
}
